import blank from './blank.png'
import environment_background from './environment_background.jpg'

export default {
    blank,
    environment_background,
}
